export { default } from './footer-menu';
